import * as React from "react";

interface Props {
    children: React.ReactNode;
    type?: "smallHeader";
}

export class StickyTableHeaderBody extends React.Component<Props> {
    public shouldComponentUpdate(): boolean {
        return false;
    }

    public render(): JSX.Element {
        return <tbody>{this.props.children}</tbody>;
    }
}
